import React from "react";
import cn from "classnames";
import {
  FaUserCircle,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaTimes,
  FaCheck,
} from "react-icons/fa";

const Leg = ({ num, status, location, type, children, onClick }) => {
  return (
    <div
      className={cn(
        "px-3 py-2 shipment mb-2 position-relative rounded",
        status === "arrived" && type === "pickup"
          ? "bg-success-lt"
          : status === "disputed"
          ? "bg-danger-lt"
          : (status === "delivered" || status === 'partial_delivered') ||
            (status === "arrived" && type === "pickup")
          ? "bg-success-lt"
          : "bg-white",
        status === "departed" && "border border-1 border-warning"
      )}
    >
      <div onClick={onClick}>
        <div
          className={cn(
            "position-absolute top-0 end-0 d-flex align-items-center justify-content-center",
            status === "disputed"
              ? "bg-danger-lt-2"
              : (status === "delivered" || status === 'partial_delivered') ||
                (status === "arrived" && type === "pickup")
              ? "bg-success-lt-2"
              : status === "voided"
              ? "bg-secondary-lt-2"
              : "bg-light",
            status === "departed" &&
              "border border-top-0 border-end-0 border-1 border-warning"
          )}
          style={{
            height: 50,
            width: 50,
            borderBottomLeftRadius: 40,
            borderBottomRightRadius: 5,
            borderTopLeftRadius: 5,
            borderTopRightRadius: 8,
          }}
        >
          <div className="mt-n1 me-n1">
            {status === "disputed" || status === "voided" ? (
              <FaTimes color="white" size={18} />
            ) : (status === "delivered" || status === "partial_delivered") ||
              (status === "arrived" && type === "pickup") ? (
              <FaCheck color="white" size={18} />
            ) : (
              <div className="fw-bold text-black-50" style={{ fontSize: 18 }}>
                {num}
              </div>
            )}
          </div>
        </div>
        <div className="d-flex gap-2 flex-row align-items-center">
          <div>
            <span className={cn(`badge type-${type}-lt ms-auto my-1`)}>
              {type?.replace("_", " ")}
            </span>
          </div>
          <div>
            <span className={cn(`badge status-${status}-lt ms-auto my-1`)}>
              {status?.replace("_", " ")?.replace("voided", "void")}
            </span>
          </div>
        </div>
        <div className="d-flex flex-row align-items-center my-2">
          <div className="px-1 text-center">
            <FaUserCircle color="#202020" size={16} />
          </div>
          <div className="text-break ps-1">
            <div className="fs-7">{location?.name}</div>
          </div>
        </div>
        <div className="d-flex flex-row align-items-center my-2">
          <div className="px-1 text-center">
            <FaPhoneAlt color="#202020" size={15} />
          </div>
          <div className="text-break ps-1">
            <div className="fs-7">{location?.phone_number}</div>
          </div>
        </div>
        <div className="d-flex flex-row my-2">
          <div className="px-1 text-center">
            <FaMapMarkerAlt color="#202020" size={15} />
          </div>
          <div className="text-break ps-1">
            <div className="fw-bold fs-7">{location?.address}</div>
            <small>{`${location?.region?.district_name}, ${location?.region?.regency_name}, ${location?.region?.province_name}`}</small>
          </div>
        </div>
      </div>

      {children}
    </div>
  );
};

export default Leg;
